/**
 * @description SweetAlert Modal 選擇使用 ICon 用
 */
export enum SweetAlertIcon {
    Info = 'information',
    Announce = 'announce'
}
